import api from './api';

export const aboutService = {
  getAbout: async () => {
    const response = await api.get('/about');
    return response.data;
  },

  updateAbout: async (formData) => {
    const response = await api.put('/about', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
};